<template>
	<div class="measurementTracker">
		<AppHeader></AppHeader>
		<div class="page-wrapper">
			<div class="container-fluid">
				<!-- Title -->
				<div class="row heading-bg">
					<div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
						<h5 style="margin-left:10px;" class="txt-dark">Shopping List</h5>
					</div>
					<div style="padding-right:35px;padding-top:5px;" class="col-lg-9">
						<a v-if="shopping_list.length == 0" href="#" @click="$router.push('/food-tracker')" class="btn btn-nutri-green pull-right clearItems btn-size">&nbsp;Add Items</a>						
						<a v-if="!shopping_list.length == 0" href="#" data-toggle="modal" data-target="#exampleModal" class="btn btn-nutri-green pull-right clearItems btn-size">&nbsp;Clear List</a>
						<a v-if="!shopping_list.length == 0" style="margin-right:30px;" href="#" data-toggle="modal" data-target="#sendModal" class="btn btn-nutri-green pull-right clearItems btn-size">&nbsp;Send List to Supermarket</a>
						<a v-if="!shopping_list.length == 0" id="print" style="margin-right:30px;" class="btn btn-nutri-green pull-right clearItems btn-size" @click="printList('print')">Print this page</a>
					</div>
				</div>
				<!-- Modal Shopping-->
				<div class="modal fade" id="sendModal" tabindex="-1" role="dialog" aria-labelledby="sendModalLabel" aria-hidden="true">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="sendModalLabel">Clear Shopping List</h5>
						</div>
						<div class="modal-body">
							<label for="">Shopping Markets</label>
							<small>Select a shopping market you would like to send your shopping list to.</small>
							<div style="margin-top:10px;">
								<select v-model="market" name="" id="" class="form-control">
									<option v-for="(item, index) in markets_list" v-bind:key="index">{{item.name}}</option>
								</select>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
							<button type="button" class="btn btn-nutri-green" data-dismiss="modal" data-toggle="modal" data-target="#questionModal">Okay</button>
						</div>
						</div>
					</div>
				</div>
				<div class="modal fade" id="questionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Shopping List</h5>
						</div>
						<div class="modal-body">
							Are you sure you want to send an email with your shopping items to the choosen market?
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-nutri-red" data-dismiss="modal" data-toggle="modal" data-target="#sendModal">Cancel</button>
							<button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="sendList()">Okay</button>
						</div>
						</div>
					</div>
				</div>
				<!-- Modal Delete -->
				<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Clear Shopping List</h5>
						</div>
						<div class="modal-body">
							Are you sure you want to clear your shopping list?
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
							<button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="clearList()">Okay</button>
						</div>
						</div>
					</div>
				</div>
				<!-- /Title -->
				<p style="margin-left:5px;" v-if="shopping_list.length == 0">No items in your shopping list</p>
				<div class="row">
					<div class="col-lg-12 col-md-12">
						<ul class="todo-list">
							<div v-for="(value, index) in shopping_list" :key="index">
								<li class="todo-item">
									<input type="checkbox" :checked="value.is_done != '0'" :id="'checkbox' + index" @change="toggleStatus(value.id)" />&nbsp;&nbsp;&nbsp;
									<label :for="'checkbox' + index">{{value.description}}</label>
									<a href="#" data-toggle="modal" data-target="#exampleModal2" @click="temp_id = value.id" class="btn btn-nutri-red btn-xs pull-right clearItems"><i class="fa fa-trash"></i>&nbsp;&nbsp;&nbsp;Delete</a>
								</li>
								<li>
									<hr class="light-grey-hr" />
								</li>
							</div>
						</ul>
						<!-- /Todo-List -->
					</div>
				</div>
				<div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Delete Shopping Item</h5>
						</div>
						<div class="modal-body">
							Are you sure you want to delete this item?
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
							<button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="deleteItem(temp_id)">Okay</button>
						</div>
						</div>
					</div>
				</div>
			</div>
			<!-- /Main Content -->
			<AppFooter></AppFooter>
		</div>
	</div>
</template>

<script>

import API from '../../services/api.js';
import AppHeader from '../../components/common/AppHeader.vue'
import AppFooter from '../../components/common/AppFooter.vue'
import {
	mapMutations
} from 'vuex';
const api = new API();

export default {
	data() {
		return {
			shopping_list:[],
			temp_id: 0,
			markets_list:null,
			market:null,
		}
	},
	components:{
			AppHeader,
			AppFooter,
	},
	created() {
		this.getShoppingList();
		this.getShoppingMarkets();
	},
	methods: {
		sendList(){
			this.markets_list.forEach(element => {
				if(element.name == this.market){
					this.market = element
				}
			});
			api.sendShoppingEmail(this.market).then(response => {
				this.getShoppingList();
			});
		},
		getShoppingMarkets(){
			api.getShoppingMarkets().then(response => {
				if (response.data.success) {
					let data = JSON.parse(response.data.data);
					this.markets_list = data;
				}
			});
		},
		getShoppingList(){
			api.getShoppingList().then(response => {
					if (response.data.success) {
						this.shopping_list = response.data.data;
					}
			});
		},
		toggleStatus(item){
			api.toggleShoppingListItem(item).then(response => {
				
			});
		},
		deleteItem(item){
			api.deleteShoppingListItem(item).then(response => {
				this.getShoppingList();
			});
		},
		clearList(){
			this.shopping_list.forEach(element => {
				this.deleteItem(element.id)
			});
		},
		printList(print){
			  window.print(print);
			  this.clearList();
		},
	}
}
</script>

<style scoped>
	.btn-size{
		width: 230px;
	}

	.btn{
		border-radius: 3px;
	}

	.shoppingTitle{
		margin-left: 5px;
	}

	@media print {
    .clearItems {
      display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/ShoppingList/ShoppingList.vue